import Tool, { type ToolArgs } from '../../../tools/Tool';
import BlockUtils from '../BlockUtils';
import AhaEditor from '../../../AhaEditor';
import TableUtils from '../../TablePlugin/TableUtils';

// General purpose tool for toggling blocks.
// It's intended to be subclassed, not used directly.
class ToolToggleBlock extends Tool {
  static blockType: string;

  static action({ editor }: ToolArgs): void {
    if (!this.blockType) {
      throw new Error(
        'You must define a static "blockType" property in block tools.'
      );
    }
    if (!editor?.selection) return;

    const ahaEditor = AhaEditor.getForEditor(editor);
    const tableSelection =
      ahaEditor?.controller?.state.pluginState.tableSelection;
    const tableWithinSelection = TableUtils.isTableWithinSelection(editor);

    if (tableWithinSelection && tableSelection) {
      TableUtils.applyToTable(editor, tableSelection, () =>
        BlockUtils.toggleBlock(editor, this.blockType)
      );
    } else {
      BlockUtils.toggleBlock(editor, this.blockType);
    }
  }

  static isActive({ editor }: ToolArgs): boolean {
    if (!editor) return false;

    return BlockUtils.selectionIsBlockType(editor, this.blockType);
  }
}

export default ToolToggleBlock;
